import { generateMutations } from '../builder'

export default {
  ...generateMutations('getAiBook', 'aiBook'),
  ...generateMutations('postAiBookGeneration'),
  ...generateMutations('postUpdateBook'),
}
